import api from "../../../utils/api";

// Create CI
export const createCi = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.post("/ci/", payload);
  return res.data;
};

// Read CI by ID
export const readCi = async (publicId) => {
  if (!publicId) throw new Error("Missing or invalid ID for CI");
  const res = await api.get(`/ci/${publicId}`);
  return res.data;
};

// Read list of CIs
export const readCis = async (params) => {
  const res = await api.get("/ci", params ? { params } : {});
  return res.data;
};

// Update CI
export const updateCi = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  if (!payload.public_id) throw new Error("Missing or invalid ID for CI");
  const res = await api.put(`/ci/${payload.public_id}`, payload);
  if (process.env.NODE_ENV === "development") console.log(res.data);
  return res.data;
};

// Delete CI
export const deleteCi = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId) throw new Error("Invalid ID for CI!");
  return await api.delete(`/ci/${publicId}`);
};
